"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeHtmlEntities = exports.ensureURLWithHTTPS = exports.displayElement = exports.ensureNonEmptyStringOrUndefined = exports.slugifyKey = exports.ellipsis = void 0;
const react_1 = __importDefault(require("react"));
const slugify_1 = __importDefault(require("slugify"));
const ellipsis = (text, limit) => {
    if (!text) {
        return '';
    }
    if (text.length > limit) {
        return text.substring(0, limit) + '…';
    }
    return text;
};
exports.ellipsis = ellipsis;
// Creating a key slug to be used in ICU translation select format and mapping.
const slugifyKey = (key, strict = false) => (0, slugify_1.default)(key ?? '', { locale: 'en', lower: true, trim: true, replacement: '_', strict });
exports.slugifyKey = slugifyKey;
const ensureNonEmptyStringOrUndefined = (property) => {
    return !!property && property.trim().length > 0 ? property : undefined;
};
exports.ensureNonEmptyStringOrUndefined = ensureNonEmptyStringOrUndefined;
const displayElement = (elementString, text, addClassName) => {
    if (!text || text.trim().length === 0) {
        return null;
    }
    return react_1.default.createElement(elementString, { className: addClassName }, text);
};
exports.displayElement = displayElement;
const ensureURLWithHTTPS = (url) => {
    if (url?.indexOf('https://') === -1 && url?.indexOf('http://') === -1) {
        url = 'https://' + url;
    }
    return url;
};
exports.ensureURLWithHTTPS = ensureURLWithHTTPS;
const decodeHtmlEntities = (encodedText) => {
    const helperElement = document.createElement('textarea');
    helperElement.innerHTML = encodedText;
    return helperElement.value;
};
exports.decodeHtmlEntities = decodeHtmlEntities;
